const translations = {
  en: {
    win: "You Win!",
    lose: "You Lose...",
    welcome: "Welcome to...",
    checkers: "Checkers!",
    chooseOption: "Choose an option:",
    easy: "Easy",
    medium: "Medium",
    hard: "Hard",
    reset: "Reset",
    quit: "Quit",
    you: "You:",
    enemy: "Enemy:",
    soldiers: "Soldiers",
    kings: "Kings",
  },
  pt: {
    win: "Ganhas-te!",
    lose: "Perdeste...",
    welcome: "Bem vindo a...",
    checkers: "Damas!",
    chooseOption: "Escolha uma opção:",
    easy: "Fácil",
    medium: "Médio",
    hard: "Difícil",
    reset: "Reiniciar",
    quit: "Sair",
    you: "Eu:",
    enemy: "Inimigo:",
    soldiers: "Soldados",
    kings: "Rainhas"
  },
  es: {
    win: "¡Ganaste!",
    lose: "Perdiste...",
    welcome: "Bienvenido a...",
    checkers: "Damas!",
    chooseOption: "Elige una opción:",
    easy: "Fácil",
    medium: "Medio",
    hard: "Difícil",
    reset: "Reiniciar",
    quit: "Salir",
    you: "Tú:",
    enemy: "Enemigo:",
    soldiers: "Soldados",
    kings: "Reinas"
  },
  fr: {
    win: "Tu as gagné!",
    lose: "Tu as perdu...",
    welcome: "Bienvenue à...",
    checkers: "Dames!",
    chooseOption: "Choisissez une option:",
    easy: "Facile",
    medium: "Moyen",
    hard: "Difficile",
    reset: "Réinitialiser",
    quit: "Quitter",
    you: "Vous:",
    enemy: "Ennemi:",
    soldiers: "Soldats",
    kings: "Reines"
  }
};

export const getTranslation = (locale, key) => {
  return translations[locale][key] || translations.en[key] || key;
};



// WEBPACK FOOTER //
// ./src/i18n.js